module.exports = __webpack_public_path__ + "img/keypad-grey.9e8d55b5.svg";